import { useQuery } from '@tanstack/react-query';

import { useUser } from '~/app/contexts/UserContext';
import { peoplePlatformApi } from '~/shared/services/api';

type GetZonesAPIResponse = Array<string>;

function getZones() {
  return peoplePlatformApi.get<GetZonesAPIResponse>('zones');
}

function isUUID(value: string): boolean {
  const uuidRegex =
    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
  return uuidRegex.test(value);
}

type UseGetZonesOptions = {
  enabled?: boolean;
  filterByManagedZones?: boolean;
};

export function useGetZones({
  enabled = true,
  filterByManagedZones,
}: UseGetZonesOptions = {}) {
  const user = useUser();

  return useQuery({
    queryKey: ['useGetZones'],
    queryFn: getZones,
    select: ({ data }) =>
      data
        .filter(Boolean)
        .filter(zone => !isUUID(zone)) // Remove UUID entries
        .filter(zone => zone !== 'ZXV') // Remove ZXV entries
        .sort((a, b) => a.localeCompare(b))
        .filter(zone => {
          if (
            user.roles?.isZoneAdmin &&
            !user.roles.isGlobalAdmin &&
            filterByManagedZones
          ) {
            return user.managedZones?.includes(zone);
          }

          return true;
        }),
    staleTime: Infinity,
    cacheTime: Infinity,
    enabled,
  });
}
